import React, { Component, Fragment } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Image from '../../../../../config/images/logoTranskrip';
import Arial from '../../../../../config/fonts/arial';
import ArialBold from '../../../../../config/fonts/arial-bold';
import DejavuBold from '../../../../../config/fonts/dejavu-bold';
import Dejavu from '../../../../../config/fonts/dejavu';
import { DateIndo } from '../../../../../utils/helpers';
import ttdFtd from '../../../../../config/images/ttdFtd';
import ttdFeb from '../../../../../config/images/ttdFeb';

class PrintTranskripSementara extends Component {
    state = {
        nama: "",
        listDataFix: [],
        listD: [],
        listE: []
    };

    getParams = () => {
        if (this.props.location.state != undefined) {
            var today = new Date()
            this.setState({
                tglsekarang: today,
                listDataFix: this.props.location.state.list,
                listD: this.props.location.state.listD,
                listE: this.props.location.state.listE,
                totalsks: this.props.location.state.totalsks,
                totalSKsN: this.props.location.state.totalSKsN,
                ipk: this.props.location.state.ipk,
                totalD: this.props.location.state.totalD,
                totalE: this.props.location.state.totalE,

                namaMhs: this.props.location.state.nama,
                nimMhs: this.props.location.state.nim,

                jurusan: this.props.location.state.jurusan,
                fakultas: this.props.location.state.fakultas,

                judulTA: this.props.location.state.judulTA,
                tgl_cetaktranskrip: this.props.location.state.tgl_cetaktranskrip,

                ttl: this.props.location.state.ttl,

                namadekan: this.props.location.state.namadekan,
                nidndekan: this.props.location.state.nidndekan,

                angkatan: this.props.location.state.angkatan
            }, () => {
                this.print()
            })
        }
    }

    print = () => {
        const doc = new jsPDF();

        doc.addFileToVFS("Arial.ttf", Arial.data);
        doc.addFont("Arial.ttf", "Arial", "normal");
        doc.addFileToVFS("Arial-Bold.ttf", ArialBold.data);
        doc.addFont("Arial-Bold.ttf", "Arial-Bold", "normal");
        doc.addFileToVFS("Dejavu-Bold.ttf", DejavuBold.data);
        doc.addFont("Dejavu-Bold.ttf", "Dejavu-Bold", "normal");
        doc.addFileToVFS("Dejavu.ttf", Dejavu.data);
        doc.addFont("Dejavu.ttf", "Dejavu", "normal");
        var imageAsia = Image.data

        doc.addImage(imageAsia, 'JPEG', 95, 7, 19, 19)

        var width = doc.internal.pageSize.getWidth()
        doc.setFont("Dejavu-Bold")
        doc.setFontSize(10.9);
        doc.text(this.state.fakultas, width / 2, 32, { align: 'center' });

        doc.setFont("Dejavu")
        doc.setFontSize(10.4);
        doc.text('Jl. Soekarno-Hatta, Rembuksari 1A Malang Telp.(0341) 478877 Fax.(0341) 4345225', width / 2, 38, { align: 'center' });

        doc.setFont("Dejavu")
        doc.setFontSize(10.4);
        doc.text('www.asia.ac.id | email: asia@asia.ac.id', width / 2, 44, { align: 'center' });

        doc.setLineWidth(0.28)
        doc.line(7, 49, 204, 49)

        doc.setFont("Arial-Bold");
        doc.setFontSize(10.9);
        doc.text("Transkrip Nilai ( Sementara )", width / 2, 58, { align: 'center' });

        doc.autoTable({
            html: '#headerTabel',
            startY: 66,
            theme: 'plain',
            styles: {
                font: 'Arial',
                lineColor: 'black',
                textColor: 'black',
                fontSize: '8.65',
                cellPadding: 0.5
            },
            margin: { left: 7, right: 7, },
            columnStyles: {
                0: { cellWidth: 26 },
                1: { cellWidth: 3 },
                2: { cellWidth: 71.5, font: 'Arial-Bold', fontSize: '8.5' },
                3: { cellWidth: 21 },
                4: { cellWidth: 3 },
                5: { font: 'Arial-Bold', fontSize: '8.5' }
            },
        });

        doc.autoTable({
            html: '#tabelTranskrip',
            theme: 'plain',
            startY: doc.lastAutoTable.finalY + 0.5,
            styles: {
                font: 'Arial',
                textColor: 'black',
                cellPadding: { top: 0.4, bottom: 0.4, left: 1.1, right: 1.1 },
                fontSize: '7.6',
            },
            headStyles: {
                valign: 'middle',
                halign: 'center',
                cellPadding: 1.5
            },
            columnStyles: {
                0: { cellWidth: 8.5, halign: 'center' },
                1: { cellWidth: 69.4 },
                2: { cellWidth: 8.5, halign: 'center' },
                3: { cellWidth: 12, halign: 'center' },
                4: { cellWidth: 8.5, halign: 'center' },
                5: { cellWidth: 69.4 },
                6: { cellWidth: 8.5, halign: 'center' },
                7: { cellWidth: 12, halign: 'center' },
            },
            margin: { left: 7, right: 7, },
            willDrawCell: (data) => {
                if (data.column.index != 0 && data.column.index != 4) {
                    doc.setDrawColor(0, 0, 0)
                    doc.setLineWidth(0.2);
                    doc.line(data.cell.x, data.cell.y + data.row.height, data.cell.x, data.cell.y);
                }
                if (data.column.index == 0) {
                    doc.setDrawColor(0, 0, 0)
                    doc.setLineWidth(0.2);
                    doc.line(data.cell.x, data.cell.y + data.row.height, data.cell.x, data.cell.y);
                }
                if (data.column.index == 4) {
                    doc.setDrawColor(0, 0, 0)
                    doc.setLineWidth(0.85);
                    doc.line(data.cell.x, data.cell.y + data.row.height, data.cell.x, data.cell.y);
                }
                if (data.column.index == 7) {
                    doc.setDrawColor(0, 0, 0)
                    doc.setLineWidth(0.2);
                    doc.line(
                        data.cell.x + data.cell.width,
                        data.cell.y,
                        data.cell.x + data.cell.width,
                        data.cell.y + data.cell.height
                    );
                }
                if (data.row.index == 0) {
                    doc.setDrawColor(0, 0, 0);
                    doc.setLineWidth(0.2);
                    doc.line(
                        data.cell.x,
                        data.cell.y,
                        data.cell.x + data.cell.width,
                        data.cell.y
                    );
                }
                var rows = data.table.body;
                if (data.row.index === rows.length - 1) {
                    doc.setDrawColor(0, 0, 0);
                    doc.setLineWidth(0.1);
                    doc.line(
                        data.cell.x,
                        data.cell.y + data.cell.height,
                        data.cell.x + data.cell.width,
                        data.cell.y + data.cell.height
                    );
                }
            },
            didParseCell: function (data) {
                if (data.section === "body" && data.row.index == 0) {
                    data.cell.styles.cellPadding = { top: 2.5, bottom: 0.5, left: 1, right: 1 }
                }
                if (data.section === "head" && data.row.index == 0) {
                    data.cell.styles.font = 'Arial-Bold'
                }
            }
        });

        doc.autoTable({
            html: '#ketTabel',
            theme: 'plain',
            startY: doc.lastAutoTable.finalY + 4,
            styles: {
                font: 'Arial',
                lineColor: 'black',
                textColor: 'black',
                fontSize: '8.65',
                cellPadding: 0.5
            },
            margin: { left: 7, right: 7, },
            columnStyles: {
                0: { cellWidth: 27 },
                1: { cellWidth: 4 },
                2: { font: 'Arial-Bold' },
            },
            didParseCell: function (data) {
                var rows = data.table.body;
                if (data.row.index === rows.length - 4) {
                    data.cell.styles.cellPadding = { bottom: 5, top: 0.5, left: 0.5, right: 0.5 }
                }
            }
        });

        let fakultas = this.state.fakultas

        doc.autoTable({
            html: '#ttdTabel',
            theme: 'plain',
            startY: doc.lastAutoTable.finalY + 0,
            styles: {
                font: 'Arial-Bold',
                lineColor: 'black',
                textColor: 'black',
                fontSize: '8.65',
                cellPadding: 0.5
            },
            margin: { left: 7, right: 7, },
            columnStyles: {
                0: { cellWidth: 130 },
            },
            didParseCell: function (data) {
                var rows = data.table.body;
                if (data.row.index === rows.length - 2) {
                    data.cell.styles.cellPadding = { top: 0, bottom: 23, left: 0, right: 0 }
                }
            },
            didDrawCell: function (data) {
                let ttd
                let width
                let height
                if (fakultas == "FAKULTAS TEKNOLOGI DAN DESAIN") {
                    ttd = ttdFtd.data
                    width = 53
                    height = 24
                }else{
                    ttd = ttdFeb.data
                    width = 41
                    height = 24
                }
                if (data.column.index === 1 && data.row.index === 2) {
                    doc.addImage(ttd, data.cell.x + 1, data.cell.y + 1, width, height);
                }
            }
        });

        doc.autoTable({
            html: '#nilaiTabel',
            theme: 'plain',
            startY: doc.lastAutoTable.finalY + 0,
            styles: {
                font: 'Arial',
                lineColor: 'black',
                textColor: 'black',
                fontSize: '8.65',
                cellPadding: 0.5
            },
            margin: { left: 7, right: 7, },
            columnStyles: {
                0: { cellWidth: 27 },
                1: { cellWidth: 4 },
                2: { cellWidth: 2 }
            }
        });

        window.open(doc.output('bloburl'), '_blank')
        window.history.go(-1);
    }

    componentDidMount = () => {
        this.getParams()
    }

    render() {
        return (
            <div style={{ display: 'none' }}>
                <table id="headerTabel">
                    <thead></thead>
                    <tbody className='times'>
                        <tr>
                            <td>Nama Mahasiswa</td>
                            <td> : </td>
                            <td>{this.state.namaMhs}</td>

                            <td>Angkatan</td>
                            <td> : </td>
                            <td>{this.state.angkatan}</td>
                        </tr>
                        <tr>
                            <td>NIM</td>
                            <td> : </td>
                            <td>{this.state.nimMhs}</td>

                            <td>Program Studi</td>
                            <td> : </td>
                            <td>
                                {
                                    this.state.jurusan == "Manajemen" ?
                                        <td>Manajemen</td>
                                        :
                                        this.state.jurusan
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table id="tabelTranskrip">
                    <thead>
                        <tr>
                            <th>
                                <center>No</center>
                            </th>
                            <th>
                                <center>Mata Kuliah</center>
                            </th>
                            <th>
                                <center>SKS</center>
                            </th>
                            <th>
                                <center>Nilai</center>
                            </th>

                            <th>
                                <center>No</center>
                            </th>
                            <th>
                                <center>Mata Kuliah</center>
                            </th>
                            <th>
                                <center>SKS</center>
                            </th>
                            <th>
                                <center>Nilai</center>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.listDataFix.map((list, i) => {
                            return (
                                <tr key={i}>
                                    <td>
                                        <center>{list.no}</center>
                                    </td>
                                    <td>{list.matakuliah.toUpperCase()}</td>
                                    <td>
                                        <center>{list.sks}</center>
                                    </td>
                                    <td>
                                        <center>{list.grade}</center>
                                    </td>
                                    {
                                        list.matched == undefined ?
                                            <>
                                                <td>
                                                    <center>&nbsp;</center>
                                                </td>
                                                <td></td>
                                                <td>
                                                    <center></center>
                                                </td>
                                                <td>
                                                    <center></center>
                                                </td>
                                            </>
                                            :
                                            <>
                                                <td>
                                                    <center>{list.matched.no}</center>
                                                </td>
                                                <td>{list.matched.matakuliah.toUpperCase()}</td>
                                                <td>
                                                    <center>{list.matched.sks}</center>
                                                </td>
                                                <td>
                                                    <center>{list.matched.grade}</center>
                                                </td>
                                            </>
                                    }
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                <table id="ketTabel">
                    <thead></thead>
                    <tbody className='times'>
                        <tr>
                            <td>Judul Tugas Akhir</td>
                            <td>:</td>
                            <td>{this.state.judulTA}</td>
                        </tr>
                        <tr>
                            <td>Total NA x SKS</td>
                            <td>:</td>
                            <td>{this.state.totalSKsN}</td>
                        </tr>
                        <tr>
                            <td>Jumlah SKS</td>
                            <td>:</td>
                            <td>{this.state.totalsks}</td>
                        </tr>
                        <tr>
                            <td>IP Kumulatif</td>
                            <td>:</td>
                            <td>{this.state.ipk}</td>
                        </tr>
                    </tbody>
                </table>

                <table id="ttdTabel">
                    <thead></thead>
                    <tbody className='times'>
                        <tr>
                            <td></td>
                            <td>Malang, {this.state.tgl_cetaktranskrip}</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>Dekan,</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>

                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                {this.state.namadekan}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table id="nilaiTabel">
                    <thead></thead>
                    <tbody className='times'>
                        <tr>
                            <td>Total Nilai D</td>
                            <td>:</td>
                            <td width='10px'></td>
                            <td>{this.state.totalD} Mata Kuliah</td>
                        </tr>
                        <tr>
                            <td colSpan={4}></td>
                            <td>
                                {
                                    this.state.listD.map((list, i) => {
                                        return (
                                            <p>{i + 1}. {list}</p>
                                        )
                                    })
                                }
                            </td>
                        </tr>
                        <tr>
                            <td>Total Nilai E</td>
                            <td>:</td>
                            <td width='10px'></td>
                            <td>{this.state.totalE} Mata Kuliah</td>
                        </tr>
                        <tr><td colSpan={4}></td></tr>
                        {
                            this.state.listE.map((list, i) => {
                                return (
                                    <tr key={i}>
                                        <td colSpan={3}></td>
                                        <td>
                                            {i + 1}. {list}
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    }
}

export default PrintTranskripSementara;
